/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts } from './FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts';
import {
    instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts,
    FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSON,
    FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSONTyped,
    FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsToJSON,
} from './FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts';

/**
 * @type FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOpts
 * Настройки для Unity webgl context
 * @export
 */
export type FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOpts = FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts;

export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSON(json: any): FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOpts {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOpts {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts(json)) {
        return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSON(json: any): any {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSONTyped(json, false);
}

export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSONTyped(value?: FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOpts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts(value)) {
        return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsToJSON(value as FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts);
    }

    return {};
}

